import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, Text, TextButton } from '@calm-web/design-system';

export const Wrapper = styled.div`
	margin-bottom: 5rem;
`;

export const Divider = styled.div`
	background: #c6c6c6;
	height: 1px;
	margin: 24px 0;
	width: 100%;
`;

export const PaymentTitleWrapper = styled.div`
	align-items: flex-end;
	display: flex;
	margin-bottom: 8px;
`;

export const PaymentTitleHeading = styled(Text).attrs({
	el: 'h3',
	styleAs: 'h4',
	color: 'gray7',
	weight: FontWeights.Regular,
})`
	margin-bottom: 0;
	margin-right: 8px;
`;

export const Cta = styled(TextButton)`
	color: ${palette('buttonBlue')};
	cursor: pointer;
	${fontSize(FontSizes.base)};
	${fontWeight(FontWeights.Medium)};
	position: relative;
	top: -3px;
	text-decoration: underline;
`;
